export const iconFontAwesomeFilmVideoClosedCaptioning = (
	<i className="fa-solid fa-closed-captioning"></i>
);
